interface HtmlDisplayProps {
  html: string;
  className?: string;
}

function HtmlDisplay({ html, className }: HtmlDisplayProps) {
  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
}

export default HtmlDisplay;
